module.exports = __webpack_public_path__ + "img/graphic.092ce672.svg";